/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';

const TransactionItemLayout = ({ tx }) => {
  const icon = (
    <i
      style={{ width: '1.5rem', height: '1.5rem' }}
      className={`border rounded-3 p-3 border-disabled icon ${tx.icon} text-f4 me-3 d-flex justify-content-center align-items-center text-shadow`}
    />
  );
  const merchant = (
    <div className="d-flex flex-column me-auto">
      <p className="text-f5">{tx?.merchantType}</p>
      <p className="text-shadow text-f6">{tx.details}</p>
    </div>
  );

  const renderAmount = () => (
    <p
      className={`${isMobile ? 'text-end' : 'text-center'} text-f5 ${
        tx?.isPrimary ? 'text-success' : ''
      } `}>
      {`${tx?.displayAmount}`}
    </p>
  );

  return (
    <div className="row px-1 py-3 mx-0" onKeyDown={null} tabIndex={-1}>
      <div className="col-8 flex-row-center me-auto my-auto ps-0">
        {icon}
        {merchant}
      </div>
      <div className="col-4 my-auto">{renderAmount()}</div>
    </div>
  );
};

export default TransactionItemLayout;

TransactionItemLayout.propTypes = {
  tx: PropTypes.object.isRequired,
};
